import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useVehicleKey, useVehicleViewer } from '../../../Delivery/Registries/vehicleIdentityHooks';
import { vehicleClient } from './vehicleClient';
export function useVehicleDossier(id) {
    const viewer = useVehicleViewer();
    return useQuery({
        queryKey: useVehicleKey('dossier', id),
        queryFn: ()=>vehicleClient.dossier(id),
        enabled: !!viewer.tenant && !!viewer.user && !!id,
        retry: false
    });
}
export function useVehicleDetails(id, enabled, year) {
    const viewer = useVehicleViewer();
    const active = enabled && !!viewer.tenant && !!viewer.user && !!id;
    const holders = useQuery({
        queryKey: useVehicleKey('holders', id),
        queryFn: ()=>vehicleClient.holders(id),
        enabled: active,
        retry: false
    });
    const rounds = useQuery({
        queryKey: useVehicleKey('rounds', id, year),
        queryFn: ()=>vehicleClient.rounds(id, year - 7, year + 2),
        enabled: active,
        retry: false
    });
    return {
        holders,
        rounds
    };
}
/** RFI-level mismatch signals; a failed load just means no banners. */ export function useVehicleMismatchSignals(id, enabled) {
    const viewer = useVehicleViewer();
    return useQuery({
        queryKey: useVehicleKey('mismatch-signals', id),
        queryFn: ()=>vehicleClient.mismatchSignals(id),
        enabled: enabled && !!viewer.tenant && !!viewer.user && !!id,
        retry: false
    });
}
export function useVehicleLineage(id, enabled) {
    const viewer = useVehicleViewer();
    const cache = useQueryClient();
    const key = useVehicleKey();
    const query = useQuery({
        queryKey: [
            ...key,
            'lineage',
            id
        ],
        queryFn: ()=>vehicleClient.lineage(id),
        enabled: enabled && !!id && !!viewer.user && !!viewer.tenant,
        retry: false
    });
    const invalidate = ()=>cache.invalidateQueries({
            queryKey: key
        });
    const save = useMutation({
        mutationFn: (input)=>vehicleClient.saveLineage(input),
        onSuccess: invalidate,
        retry: false
    });
    const archive = useMutation({
        mutationFn: (input)=>vehicleClient.archiveLineage(input),
        onSuccess: invalidate,
        retry: false
    });
    return {
        query,
        save,
        archive
    };
}
